import { TransientEvents } from '@awork/_shared/models/transient-events.model'
import type { Notification } from '@awork/framework/models/notification.model'
import { NotificationEvents } from '@awork/framework/models/notification.types'

const aworkAI_EVENTS = new Set([
  NotificationEvents.ProjectAssigned,
  NotificationEvents.ProjectStatusChanged,
  NotificationEvents.DocumentCommented,
  NotificationEvents.DocumentCommentMentioned,
  NotificationEvents.DocumentCommentReacted,
  NotificationEvents.DocumentMentioned,
  NotificationEvents.DocumentContributorAdded,
  NotificationEvents.DocumentSpaceContributorAdded,
  NotificationEvents.CommentMentioned,
  NotificationEvents.CommentReacted,
  NotificationEvents.AgentThreadAwaitingAction,
  NotificationEvents.AgentThreadShared,
  NotificationEvents.AgentMeetingSummarized,
  NotificationEvents.AgentShared,
  NotificationEvents.AiCredits,
  NotificationEvents.AiCreditsLow,
  NotificationEvents.AiCreditsUsedUp,
  NotificationEvents.AiAgentRunBlocked,
  NotificationEvents.AiAgentRunBlockedAdmin,
  NotificationEvents.AiPlanUpgraded,
  NotificationEvents.ExportAvailable,
  NotificationEvents.ExportFailed
])

const GENERAL_TRANSIENT_EVENTS = new Set([
  TransientEvents.GeneralWelcomeBack,
  TransientEvents.GeneralUploadUserImage,
  TransientEvents.GeneralUploadWorkspaceImage,
  TransientEvents.GeneralAddContactInfo
])

/**
 * Checks whether aworkAI supports an event, including its settings row.
 * @param {NotificationEvents} event Notification event.
 * @returns {boolean} Whether the event is supported.
 */
export function supportsaworkAINotificationEvent(event: NotificationEvents): boolean {
  return aworkAI_EVENTS.has(event)
}

/**
 * Checks generic comments by their target; a document can also have project context.
 * @param {Notification} notification Notification to display in aworkAI.
 * @returns {boolean} Whether aworkAI supports the notification.
 */
export function supportsaworkAINotification(notification: Notification): boolean {
  if (!supportsaworkAINotificationEvent(notification.event)) {
    return false
  }

  if (
    notification.event === NotificationEvents.CommentMentioned ||
    notification.event === NotificationEvents.CommentReacted
  ) {
    return !notification.taskId && !notification.task && !!(notification.documentId || notification.document)
  }

  return true
}

/**
 * Keeps general profile prompts while excluding PM prompts in aworkAI.
 * @param {TransientEvents} event Transient prompt event.
 * @returns {boolean} Whether aworkAI supports the prompt.
 */
export function supportsaworkAITransientNotification(event: TransientEvents): boolean {
  return GENERAL_TRANSIENT_EVENTS.has(event)
}
